/*
 * Copyright (c) Nexign, JSC, 2020-2023.
 */
/**
 * Tariffs And Services Cards Styled
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.23.2
 * @since 1.4.0
 */

import { Typography } from '@nexign/scc-ui-kit';
import styled from 'styled-components';

import { colors } from '../../../../theme';
import { IProductsMeta } from '../../tariffsAndServicesTypes';

export const ProductsCategoryStyled = styled.div``;

export const ProductsCardsStyled = styled.div.attrs({
    className: 'products-cards',
})<{ productMeta: IProductsMeta }>`
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    width: 915px; // ie11

    margin-right: -16px;

    .product-category-${(props) => props.productMeta.campaignTariffsCategoryId} & {
        align-items: stretch;
    }

    .product-category-${(props) => props.productMeta.campaignServicesCategoryId} & .product-card {
        height: 208px;
    }
`;

export interface IProductsCardsItemStyled {
    isSelected?: boolean;
    isNewCard?: boolean;
}

export const ProductsCardsItemStyled = styled.div.attrs(({ isSelected }: IProductsCardsItemStyled) => ({
    className: `products-card-item ${isSelected ? 'selected' : ''}`,
}))<IProductsCardsItemStyled>`
    width: ${(props) => (props.isNewCard ? '265px' : '285px')};

    margin: 0 16px 16px 0;
    background: ${colors.tariffsAndServicesCardBgColor};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
    border-radius: ${(props) => (props.isNewCard ? '12px' : '4px')};
    border: 1px solid ${colors.tariffsAndServicesCardBorderColorNormal};
    align-self: ${(props) => (props.isNewCard ? 'stretch' : 'auto')};

    display: flex;

    cursor: pointer;

    &:hover {
        border: 1px solid ${colors.tariffsAndServicesCardBorderColorHover};
    }

    &.selected {
        outline: 2px solid ${colors.tariffsAndServicesCardBorderColorSelected};
        box-shadow: 0 2px 8px rgba(0, 185, 86, 0.16);
    }
`;

export const ProductCardStyled = styled.div.attrs({
    className: 'product-card',
})`
    padding: 16px;
    flex: 1 0 auto;
    width: 100%; // ie11

    display: flex;
    flex-direction: column;

    h5 {
        margin-top: 0;
        margin-bottom: 8px;
    }
`;

export const ProductsCardDescrStyled = styled.div`
    flex: 1 0 auto;

    > div {
        max-height: 100px;

        margin-top: 8px;
        margin-bottom: 8px;
    }
`;

export const ProductsCardMoreStyled = styled.div`
    display: inline;

    .file-type-icon {
        margin-left: 8px;
    }
`;

export const ProductsCardCostStyled = styled.div`
    display: flex;
    align-items: center;
    color: ${colors.tariffsAndServicesCardCostColor};
    font-size: 12px;

    span {
        color: ${colors.tariffsAndServicesCardColor};
        margin-left: 4px;
    }
`;

export const ProductsCardsNoSearchMatterStyled = styled(Typography)`
    margin-bottom: 10px;
`;
